import { DataFetchWrapper } from "@tfg/ui"

import { useFindMappingByType } from "~/gen/api"
import { MaterialMapping } from "~/pages/Brand/OrganizationSettings/Mapping/Materials/MaterialMapping.tsx"

export const MaterialMappingWrapper = () => {
  const query = useFindMappingByType("MATERIAL")

  return (
    <DataFetchWrapper query={query} acceptEmpty>
      {({ data }) => <MaterialMapping materialTypes={data.data} />}
    </DataFetchWrapper>
  )
}
